<span>Complete one or more of the fields below to search for an applicable user in your organization.</span>
<form *dynamicFormInfo="formInfo" (keyup.enter)="search()">
  <div class="row">
    <div class="col-4">
      <app-text-input controlName="lastName" placeholder="Last Name Contains"></app-text-input>
    </div>
    <div class="col-4">
      <app-text-input controlName="firstName" placeholder="First Name Contains"></app-text-input>
    </div>
    <div class="col-4">
      <app-text-input controlName="middleName" labelOverride="Middle Initial" placeholder="Middle Name Contains"></app-text-input>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <app-text-input controlName="userName" placeholder="User Name Contains"></app-text-input>
    </div>
    <div class="col-4">
      <app-select-input
        controlName="entityGroupRoleName"
        [readonly]="true"
        [overrideReadonlyValue]="selectedEntityGroupRole$"
      ></app-select-input>
    </div>
    <div class="col-4">
      <app-text-input controlName="userEmailAddress" placeholder="Enter full email address"></app-text-input>
    </div>
  </div>

  <input type="hidden" controlName="entityId" />
  <input type="hidden" controlName="entityTypeCode" />
  <input type="hidden" controlName="entityGroupRoleCode" />
</form>
